import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const orderPayment = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/payment', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const orderPaymentSettlement = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/payment-settlement', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const orderMultiplePaymentSettlement = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/multi-payment-settlement', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getOrderPaymentDetails = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/payment', // for android use
    headers: getHeaders(),
  });
};

export const updateOrderPayment = (id, storeId, orderId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/payment', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


// payload : Payment => {
//      "id":"",
//      "date" : "",
//      "receivedBy":"",
//      "paidBy":"",
//      "paymentRefNo":"",
//      "amount":233,
//      "paymentMode:""
// }
